module.exports = __webpack_public_path__ + "cb2f6fdf47f7f1b6d074bfa60e2935b3.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-88.svg
// module id = 603
// module chunks = 0